// extracted by mini-css-extract-plugin
export default {"footer-common-link":"footer-common-link_kVKlN9Xn","footer-common-link-mobile":"footer-common-link-mobile_Zslu1Orw"};